import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
import SoFormLoadsAmountControl from './SoFormLoadsAmountControl';
import SoFormLoadSubtypeControl from './SoFormLoadSubtypeControl';
//

const SoFormLoadsItems = ({ className, load }) => {
  return (
    <div className={className}>
      <SoFormLoadsAmountControl load={load} />
      <SoFormLoadSubtypeControl load={load} />
    </div>
  );
};

SoFormLoadsItems.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
  flex: none;
  /* order: 1; */
  align-self: stretch;
  flex-grow: 0;
`;

export default styled(SoFormLoadsItems)`
  ${regularCSS}
`;
